export default "__VITE_ASSET__30c47f81__"